/**
 * Переводы: испанский.
 *
 * ⚠️ КЛЮЧИ ОБЯЗАНЫ СОВПАДАТЬ ВО ВСЕХ ЧЕТЫРЁХ ЯЗЫКАХ. Пропущенный ключ не
 * ломает сборку и не роняет игру — на экране просто появляется сам ключ
 * вида «menu.shop_sell», и заметить это можно только глазами и только на
 * том языке, на котором никто не играет. Проверка парности — в index.ts
 * этой папки.
 *
 * ⚠️ РАЗДЕЛЕНО ПО ЯЗЫКАМ, А НЕ ПО РАЗДЕЛАМ ИГРЫ. Раздел («меню», «снасть»)
 * при переводе не нужен: переводчик работает с одним языком целиком, а
 * править разом четыре языка приходится только при добавлении ключа — и
 * тогда четыре файла рядом удобнее, чем четыре места в файле на 1845 строк.
 */
import { ТОВАРЫ_ES } from './goods-es.js';
import { РЫБЫ_ES } from './species-north-es.js';
import { МИР_ES } from './species-world-es.js';

export const es: Record<string, string> = {
  'fish.unknown': 'Pez en el anzuelo',
  ...ТОВАРЫ_ES,
  ...РЫБЫ_ES,
  ...МИР_ES,
  'hud.anglers_online': 'Pescadores en línea: {n}',
  'loader.ключ': 'Comprobando tu billete',
  'loader.база': 'Abriendo el diario',
  'loader.движок': 'Desenrollando el carrete',
  'loader.сцена': 'Montando el aparejo',
  'loader.локация': 'Caminando al agua',
  'loader.берег': 'Eligiendo el sitio',
  'auth.subtitle': 'Entrar al juego',
  'auth.tab_login': 'Entrar',
  'auth.tab_register': 'Registro',
  'auth.name': 'Nombre',
  'auth.name_hold': 'Cómo llamarte en el agua',
  'auth.name_hint': 'Otros pescadores verán este nombre',
  'auth.email': 'Correo',
  'auth.email_hint': 'Nadie puede ver tu correo — es información privada',
  'auth.password': 'Contraseña',
  'auth.pass_hint': 'Solo letras latinas, con al menos un dígito y una mayúscula',
  'auth.password2': 'Repite la contraseña',
  'auth.pass2_hint': 'Escríbela otra vez para que una errata no te deje fuera',
  'auth.login_btn': 'Entrar',
  'auth.register_btn': 'Crear cuenta',
  'auth.pass_min': 'Mínimo 6 caracteres',
  'set.terrain_range': 'Distancia del terreno',
  'set.terrain_range_hint': 'El mayor efecto en el fotograma: el terreno ocupa más de la mitad',
  'set.range_near': 'Cerca',
  'set.range_normal': 'Normal',
  'set.range_far': 'Lejos',
  'set.antialias': 'Suavizado',
  'set.antialias_hint': 'Quita los bloques del reescalado y los bordes dentados; cuesta relleno',
  'set.aa_off': 'No',
  'set.aa_soft': 'Suave',
  'set.aa_full': 'Completo',
  'set.render_scale': 'Escala de render',
  'set.render_scale_hint': 'La palanca más fuerte: menos es mucho más rápido pero más suave',
  'set.fish_distance': 'Distancia de peces',
  'set.fish_distance_hint': 'Más allá de este límite no se dibujan',
  'set.vol_tackle': 'Aparejo',
  'set.vol_steps': 'Pasos',
  'set.zoom': 'Zoom',
  'set.zoom_hint': 'Estrecha la vista: los objetos se ven mayores',
  'set.lang': 'Idioma',
  'set.lang_ru': 'Русский',
  'set.lang_en': 'English',
  'set.lang_uk': 'Українська',
  'set.lang_es': 'Español',
  'lobby.settings': 'Ajustes',
  'lobby.min_level': 'Disponible desde el nivel {level}',
  'set.tab_sound': 'Sonido',
  'set.tab_lang': 'Idioma',
  'set.tab_account': 'Cuenta',
  'set.vol_music': 'Música',
  'set.vol_effects': 'Sonidos del menú',
  'set.vol_note': 'El volumen se guarda en este dispositivo y no se traslada a otro.',
  'unit.kg': 'kg',
  'unit.cm': 'cm',
  'unit.m': 'm',
  'unit.g': 'g',
  'unit.mm': 'mm',
  'unit.coins': 'mon.',
  // ── Equipo y tienda ──
  'slot.rod': 'Caña',
  'slot.reel': 'Carrete',
  'slot.line': 'Línea',
  'slot.lure': 'Señuelo',
  'menu.gear': 'Inventario',
  'menu.shop': 'Nasa',
  'menu.shop_sell': 'Nasa',
  'keepnet.open_hint': 'Nasa — pulsa para abrir',
  'keepnet.title': 'Nasa',
  'keepnet.full_warn': 'La nasa está llena — vuelve a la base',
  'menu.shop_buy': 'Aparejos',
  'menu.level': 'Nivel',
  'menu.max_level': 'máximo',
  'menu.worn': 'equipado',
  'menu.owned': 'comprado',
  'menu.need_level': 'requiere nivel',
  'menu.slot_empty': 'Vacío',
  'menu.keepnet_empty': 'La nasa está vacía — ve a pescar',
  'menu.sell': 'Vender',
  'menu.sell_all': 'Marcar todo',
  'menu.sell_pick': 'Elige pescado',
  'menu.selling': 'Vendiendo…',
  'hud.caught_xp': '+{xp} de experiencia',
  'hud.catch_rejected': 'Captura no registrada',
  // ── Меню игры ──
  'menu.button': 'Menú',
  'menu.title': 'Menú',
  'menu.resume': 'Continuar',
  'menu.locations': 'Ubicaciones',
  'menu.records': 'Récords',
  'menu.mine': 'Mis capturas',
  'menu.settings': 'Ajustes',
  'menu.controls': 'Controles',
  'menu.logout': 'Cerrar sesión',
  'menu.graphics': 'Vídeo',
  'menu.sound': 'Sonido',
  'menu.game': 'Juego',
  'menu.quality': 'Calidad',
  'menu.preset_low': 'Baja',
  'menu.preset_medium': 'Media',
  'menu.preset_high': 'Alta',
  'menu.preset_custom': 'ajustes cambiados a mano',
  'menu.reset': 'Restablecer sección',
  'menu.on': 'sí',
  'menu.off': 'no',
  'menu.needs_reload': 'se aplica al reiniciar',
  'menu.loading': 'Cargando…',
  'menu.server_off': 'El servidor no responde',
  'menu.no_locations': 'Aún no hay ubicaciones',
  'menu.no_catches': 'Aún vacío',
  'menu.need_login': 'Se requiere iniciar sesión',
  'menu.you_are_here': 'estás aquí',
  'menu.ctl_move': 'Moverse',
  'menu.ctl_run': 'Correr',
  'menu.ctl_jump': 'Saltar',
  'menu.ctl_cast': 'Lanzar',
  'menu.ctl_reel': 'Recoger',
  'menu.ctl_menu': 'Menú',
  'ui.title': 'InterFishing · Visor de Mundo',
  'ui.gen_brush': 'Radio del Pincel',
  'ui.gen_lift': 'Paso por clic',
  'ui.sec_place': 'Qué colocar',
  'ui.btn_tree': 'Árbol',
  'ui.btn_bush': 'Arbusto',
  'ui.btn_grass': 'Hierba',
  'ui.btn_rock': 'Roca',
  'ui.btn_reed': 'Junco',
  'ui.btn_weed': 'Algas',
  'ui.btn_erase': 'Borrar en círculo',
  'ui.btn_loadmap': 'Cargar Mapa',
  'ui.btn_savemap': 'Guardar Mapa',
  'ui.btn_sizeup': 'Tamaño +',
  'ui.btn_sizedown': 'Tamaño −',
  'ui.help_make':
    'Apunta al suelo — el anillo amarillo mostrará dónde se aplicará el cambio.<br>    <kbd>Q</kbd> más bajo · <kbd>E</kbd> más alto · <kbd>Z</kbd> deshacer.<br>    En el modo construcción activado, <kbd>Clic Izquierdo</kbd> repite la última acción,<br>    y el lanzamiento no funciona.<br /><br>    Los cambios y objetos se guardan en el archivo junto con el mundo y sobreviven<br>    a «Reconstruir»: están en coordenadas mundiales, no en chunks.',
  'ui.help_play':
    '<kbd>W</kbd><kbd>A</kbd><kbd>S</kbd><kbd>D</kbd> caminar · <kbd>Shift</kbd> correr ·<br>    <kbd>Clic Izq</kbd> mirar<br /><br>    <b>Lanzamiento por balanceo:</b> mantén <kbd>Clic Izq</kbd>, ratón <b>hacia ti</b>, luego<br>    <b>lejos bruscamente</b>.<br /><br>    <b>Lanzamiento por presión:</b> mantén <kbd>Clic Izq</kbd> — el anillo gana fuerza,<br>    suelta — vuela. Anillo <b>Rojo</b>: exceso, caerá a tus pies.<br /><br>    En el agua <kbd>Clic Izq</kbd> — recoger línea.',
  'ui.unit_kg': 'kg',
  'ui.unit_cm': 'cm',
  'ui.unit_g': 'g',
  'ui.unit_m': 'm',
  'ui.unit_mm': 'mm',
  'ui.tab_world': 'Mundo',
  'ui.tab_gen': 'Creador',
  'ui.tab_make': 'Construcción',
  'ui.btn_collapse': 'Colapsar',
  'ui.stat_chunks': 'Chunks',
  'ui.stat_queue': 'En cola',
  'ui.stat_gen': 'Generación',
  'ui.stat_tris': 'Triángulos',
  'ui.stat_fps': 'FPS',
  'ui.stat_pos': 'Posición',
  'ui.stat_alt': 'Altitud',
  'ui.stat_seed': 'Semilla',
  'ui.ctl_zoom': 'Zoom',
  'ui.sec_weather': 'Cielo y Clima',
  'ui.stat_sun': 'Sol',
  'ui.stat_sunrise': 'Amanecer',
  'ui.stat_sunset': 'Atardecer',
  'ui.stat_daylen': 'Dur. Día',
  'ui.stat_vis': 'Visibilidad',
  'ui.stat_wind': 'Viento',
  'ui.stat_wave': 'Olas',
  'ui.ctl_time': 'Tiempo',
  'ui.ctl_weather': 'Clima',
  'ui.val_clear': 'despejado',
  'ui.ctl_force': 'Fuerza',
  'ui.btn_clock': 'Reloj activo',
  'ui.btn_wauto': 'Clima auto',
  'ui.sec_tackle': 'Aparejo',
  'ui.stat_cast': 'Lanzamiento',
  'ui.stat_tension': 'Tensión',
  'ui.stat_horizon': 'Horizonte',
  'ui.stat_depth': 'Profundidad',
  'ui.stat_tip': 'Puntera',
  'ui.stat_fish': 'Pez',
  'ui.sec_lure': 'Señuelo',
  'ui.ctl_kind': 'Tipo',
  'ui.val_spoon': 'cuchara',
  'ui.ctl_weight': 'Peso',
  'ui.ctl_dive': 'Prof. nado',
  'ui.ctl_bitex': 'Pique ×',
  'ui.sec_line': 'Línea',
  'ui.ctl_mat': 'Material',
  'ui.val_mono': 'monofil',
  'ui.ctl_dia': 'Diámetro',
  'ui.stat_break': 'Resistencia',
  'ui.sec_rod': 'Caña',
  'ui.ctl_class': 'Clase',
  'ui.val_medium': 'medio',
  'ui.ctl_len': 'Longitud',
  'ui.ctl_test': 'Test',
  'ui.ctl_action': 'Acción',
  'ui.val_mid': 'media',
  'ui.sec_rodpose': 'Pose de Caña',
  'ui.btn_tune': 'Ajustar',
  'ui.btn_std': 'Estándar',
  'ui.btn_reset': 'Reset',
  'ui.btn_sizedn': 'Tamaño −',
  'ui.stat_pose': 'Pose',
  'ui.sec_reelpose': 'Pose de Carrete',
  'ui.btn_setup': 'Configurar',
  'ui.btn_save': 'Guardar',
  'ui.btn_mode_reel': 'Modo: Carrete',
  'ui.sec_castmode': 'Modo de Lanzamiento',
  'ui.btn_swing': 'Balanceo',
  'ui.btn_newline': 'Nueva Línea',
  'ui.btn_shore': 'A la orilla',
  'ui.btn_newseed': 'Nueva Semilla',
  'ui.tr_caught': 'Capturado',
  'ui.btn_ok': 'OK',
  'ui.language': 'Idioma',
  'state.high': 'muy alto — acércate al agua',
  'state.reel_long': 'recogiendo línea larga',
  'state.click_water': 'clic en agua',
  'state.click': 'clic',
  'state.no_swing': 'soltado sin balanceo',
  'state.reel_hang': 'recogiendo: colgando',
  'state.reel_water': 'recogiendo: en agua',
  'state.release': 'soltado',
  'state.line_end': 'línea terminada',
  'state.line_break': 'rotura a {kg} kg',
  'state.came_off': 'se soltó',
  'state.hooked_reel': 'enganchado {kind}',
  'state.strike': 'clavado {kind} {kg} kg',
  'state.strike_slack': 'clavado en línea floja',
  'state.hooked_auto': 'auto-enganche {kind} {kg} kg',
  'state.spit': 'escupido',
  'state.bite': 'pique {kind} {kg} kg',
  'state.attack': 'ataque',
  'state.attack_school': 'ataque (banco) {kind} {kg} kg',
  'state.jump': 'salto',
  'state.lost_tear': 'desgarro (freno fuerte)',
  'state.lost_slack': 'pérdida (línea floja)',
  'state.lost_jump': 'pérdida (salto)',
  'state.beached': 'en orilla',
  'state.landed': 'captura {kg} kg',
  'state.lost_why': 'pérdida: {why}',
  'state.lost_swing': 'pérdida en balanceo',
  'state.splash': 'chapoteo',
  'state.reeled_slack': 'recogido hasta tenso',
  'state.reset': 'reinicio total',
  'state.in_air': 'en aire',
  'state.on_bottom': 'en fondo',
  'state.floating': 'flotando',
  'state.in_water': 'en agua',
  'hud.tab.world': 'MUNDO',
  'hud.tab.generator': 'GENERADOR',
  'hud.tab.creator': 'CREADOR',
  'hud.sec.map': 'MAPA',
  'hud.sec.sky': 'CIELO Y CLIMA',
  'hud.sec.tackle': 'APAREJO',
  'hud.sec.lure': 'SEÑUELO',
  'hud.sec.line': 'LÍNEA',
  'hud.sec.rod': 'CAÑA',
  'hud.sec.rodPose': 'POSE CAÑA',
  'hud.sec.reelPose': 'POSE CARRETE',
  'map.chunks': 'Chunks',
  'map.generation': 'Generación',
  'map.frame': 'Frame',
  'map.height': 'Altura',
  'map.seed': 'Semilla',
  'map.position': 'Posición',
  'map.scale': 'Escala',
  'map.inQueue': 'En cola',
  'map.triangles': 'Triángulos',
  'sky.sun': 'Sol',
  'sky.sunrise': 'Amanecer',
  'sky.sunset': 'Atardecer',
  'sky.dayLength': 'Duración Día',
  'sky.visibility': 'Visibilidad',
  'sky.wind': 'Viento',
  'sky.wave': 'Olas',
  'sky.time': 'Tiempo',
  'sky.weather': 'Clima',
  'sky.strength': 'Fuerza',
  'sky.clockRunning': 'Reloj activo',
  'sky.weatherAuto': 'Clima Auto',
  'weather.clear': 'despejado',
  'weather.cloudy': 'nublado',
  'weather.fog': 'niebla',
  'weather.rain': 'lluvia',
  'sun.behind': 'atrás',
  'sun.day': 'día',
  'sun.night': 'noche',
  'tackle.cast': 'Lanzamiento',
  'tackle.depth': 'Horizonte',
  'tackle.rodTip': 'Puntera',
  'tackle.fish': 'Pez',
  'tackle.tension': 'Tensión',
  'tackle.waterDepth': 'Profundidad',
  'tackle.ready': 'listo',
  'tackle.floating': 'flotando',
  'tackle.left': 'izq',
  'tackle.right': 'der',
  'lure.kind': 'Tipo',
  'lure.weight': 'Peso',
  'lure.diving': 'Prof. nado',
  'lure.noLip': 'sin babero',
  'lure.spoon': 'cuchara',
  'lure.spinner': 'cucharilla',
  'lure.wobbler': 'wobbler',
  'lure.jig': 'jig',
  'line.material': 'Material',
  'line.diameter': 'Diámetro',
  'line.breaking': 'Rotura',
  'line.dragTo': 'freno al',
  'line.mono': 'monofilamento',
  'line.fluoro': 'fluorocarbono',
  'line.braid': 'trenzado',
  'rod.class': 'Clase',
  'rod.length': 'Longitud',
  'rod.test': 'Test',
  'rod.action': 'Acción',
  'rod.ultralight': 'ultraligero',
  'rod.light': 'ligero',
  'rod.medium': 'medio',
  'rod.heavy': 'pesado',
  'action.slow': 'lenta',
  'action.medium': 'media',
  'action.fast': 'rápida',
  'btn.adjust': 'Ajustar',
  'btn.standard': 'Estándar',
  'btn.reset': 'Reset',
  'btn.sizePlus': 'Tamaño +',
  'btn.sizeMinus': 'Tamaño -',
  'btn.tune': 'Configurar',
  'btn.cancel': 'Cancelar',
  'btn.save': 'Guardar',
  'outcome.landed': 'Captura',
  'outcome.lost': 'Pérdida',
  'outcome.break': 'Rotura',
  'outcome.tackle': 'Aparejo',
  'lobby.wiki': 'Enciclopedia',
  'lobby.wiki_sub': 'todos los peces del juego',
  'wiki.who': 'Qué es',
  'wiki.where': 'Dónde buscar',
  'wiki.how': 'Con qué pescar',
  'wiki.no_rod': 'no se pesca con caña',
  'wiki.when': 'Cuándo pica',
  'wiki.bite': 'Cómo pica',
  'rare.массовая': 'abundante',
  'rare.обычная': 'común',
  'rare.нечастая': 'poco común',
  'rare.редкая': 'rara',
  'rare.очень_редкая': 'muy rara',
  'rare.единичная': 'excepcional',
  'wiki.water': 'Agua',
  'wiki.spawn': 'Desove',
  'wiki.water_band': 'de {a} a {b} °C · mejor a {opt} °C',
  'wiki.teeth': 'corta el sedal — usa bajo de línea',
  'act.дневная': 'de día',
  'act.ночная': 'de noche',
  'act.сумеречная': 'al alba y al ocaso',
  'act.круглосуточная': 'a cualquier hora',
  'flow.стоячая': 'aguas quietas',
  'flow.слабое': 'corriente lenta',
  'flow.сильное': 'corriente fuerte',
  'flow.любое': 'cualquier corriente',
  'place.трава': 'vegetación',
  'place.коряги': 'troncos sumergidos',
  'place.бровка': 'veril',
  'place.твёрдое_дно': 'fondo duro',
  'place.ил': 'fango',
  'place.камни': 'rocas',
  'place.открытая_вода': 'aguas abiertas',
  'place.поверхность': 'superficie',
  'place.перекат': 'rápido',
  'place.яма': 'hoya',
  'school.одиночка': 'vive solitario',
  'school.малая_стая': 'en grupos pequeños',
  'school.большая_стая': 'en cardúmenes densos',
  'wiki.size': 'Normalmente {t}, hasta {max}',
  'wiki.length': 'unos {n} de largo',
  'wiki.horizon': 'Profundidad {a} – {b} m',
  'wiki.retrieve': 'Recogida {a} – {b} m/s',
  'wiki.window': '{n} s para clavar',
  'wiki.strike': 'Clavada {n} m/s',
  'wiki.k_hard': 'seca',
  'wiki.k_mid': 'normal',
  'wiki.k_soft': 'suave',
  'mouth.плёночная': 'labios membranosos',
  'mouth.тонкогубая': 'labios finos',
  'mouth.костистая': 'mandíbula ósea',
  'mouth.панцирная': 'mandíbula con colmillos',
  'mouth.кожистая': 'labios coriáceos',
  'mouth.хрящевая': 'boca tubular cartilaginosa',
  'wiki.thick': 'grosor del cuerpo {n} cm',
  'wiki.soon': 'Aún no está en el juego',
  'wiki.soon_note': 'Llegará al crecer el juego',
  'wiki.h_top': 'cerca de la superficie',
  'wiki.h_mid': 'a media agua',
  'wiki.h_deep': 'cerca del fondo',
  'wiki.s_slow': 'lenta',
  'wiki.s_mid': 'media',
  'wiki.s_fast': 'rápida',
  'wiki.w_short': 'poco tiempo',
  'wiki.w_ok': 'tiempo suficiente',
  'wiki.f_weak': 'débil',
  'wiki.f_mid': 'ágil',
  'wiki.f_strong': 'fuerte',
  'wiki.lip_soft': 'boca blanda',
  'wiki.lip_mid': 'boca normal',
  'wiki.lip_hard': 'boca dura',
  'wiki.stamina': 'resiste hasta {n} s',
  'wiki.jump_no': 'no salta',
  'wiki.jump_rare': 'salta a veces',
  'wiki.jump_often': 'salta a menudo',
  'fam.карповые': 'ciprínidos',
  'fam.лососёвые': 'salmónidos',
  'fam.сиговые': 'coregonos',
  'fam.окунёвые': 'pércidos',
  'fam.осетровые': 'esturiones',
  'fam.сомовые': 'siluros',
  'fam.щуковые': 'lucios',
  'fam.центрарховые': 'centrárquidos',
  'fam.бычковые': 'gobios',
  'fam.вьюновые': 'lochas',
  'fam.корюшковые': 'eperlanos',
  'fam.миноговые': 'lampreas',
  'fam.прочие': 'otros',
  'fam.сельдевые': 'sábalos',
  'fam.змееголовые': 'cabezas de serpiente',
  'fam.панцирниковые': 'peces caimán',
  'fam.цихловые': 'cíclidos',
  'fam.харациновые': 'carácidos',
  'fam.ауховые': 'percas chinas',
  'bait.мушка': 'mosca artificial',
  'bait.ручейник': 'larva de frigánea',
  'bait.икра': 'huevas de pez',
  'bait.резка': 'pez cortado',
  'bait.кузнечик': 'saltamontes',
  'bait.зелень': 'algas filamentosas',
  'bait.лягушка': 'rana',
  'bait.фрукт': 'fruta',
  'bait.мясо': 'carne',
  'bait.хлеб': 'pan',
  'bait.червь': 'lombriz',
  'bait.опарыш': 'gusano',
  'bait.мотыль': 'larva roja',
  'bait.кукуруза': 'maíz',
  'bait.перловка': 'cebada',
  'bait.тесто': 'masa',
  'bait.горох': 'guisante',
  'bait.бойл': 'boilie',
  'bait.пеллетс': 'pellets',
  'bait.ракушка': 'almeja',
  'bait.живец': 'pez vivo',
  'bait.рачок': 'crustáceo',
  'wiki.ingame': 'En juego',
  'wiki.find': 'Escribe un nombre',
  'wiki.nothing': 'No se ha encontrado nada',
  'wiki.red': 'Lista Roja',
  'wiki.red_note': 'Especie protegida. Este pez siempre se devuelve al agua: no entra en la nasa ni se puede vender, pero la captura sigue dando experiencia y una línea propia en los récords.',
  'lang.ru': 'RU',
  'lang.en': 'EN',
  'lang.uk': 'UK',
  'lang.es': 'ES',
  'ui.tab_gen_old': 'Generador',
  'ui.tab_map_title': 'Mapa: buscar en agua real',
  'ui.tab_map': 'Mapa',
  'ui.btn_rebuild_title': 'Aplicar ediciones y reconstruir mundo',
  'ui.btn_rebuild': 'Reconstruir',
  'ui.unit_ms': 'ms',
  'ui.unit_mps': 'm/s',
  'ui.unit_beaufort': 'bft',
  'ui.stat_line_reserve': 'LÍNEA RSRV',
  'ui.stat_drag': 'FRENO',
  'ui.stat_reel': 'VELOCIDAD',
  'ui.make_on': 'Construir ON',
  'ui.make_off': 'Construir off',
  'ui.ready_to_cast': 'LISTO PARA LANZAR',
  'state.has_edits': 'hay cambios — haz clic en «Reconstruir»',
  'state.world_built': 'mundo construido',
  'state.rebuilding': 'reconstruyendo...',
  'rhumb.С': 'N',
  'rhumb.ССВ': 'NNE',
  'rhumb.СВ': 'NE',
  'rhumb.ВСВ': 'ENE',
  'rhumb.В': 'E',
  'rhumb.ВЮВ': 'ESE',
  'rhumb.ЮВ': 'SE',
  'rhumb.ЮЮВ': 'SSE',
  'rhumb.Ю': 'S',
  'rhumb.ЮЮЗ': 'SSO',
  'rhumb.ЮЗ': 'SO',
  'rhumb.ЗЮЗ': 'OSO',
  'rhumb.З': 'O',
  'rhumb.ЗСЗ': 'ONO',
  'rhumb.СЗ': 'NO',
  'rhumb.ССЗ': 'NNO',
  'tackle.aim': 'balanceo',
  'tackle.flying': 'volando',
  'tackle.reeling': 'recogiendo',
  'tackle.taut': 'tensa',
  'tackle.slack': 'floja',
  'tackle.overload': 'SOBRECARGA',
  'tackle.straight': 'recta',
  'ui.sec_pond': 'Estanque',
  'ui.sec_edge': 'Borde',
  'ui.sec_bank': 'Orilla',
  'ui.sec_relief': 'Relieve',
  'ui.sec_ground': 'Terreno',
  'wind.calm': 'calma',
  'wind.light_air': 'ventolina',
  'wind.light_breeze': 'brisa ligera',
  'wind.gentle_breeze': 'brisa suave',
  'wind.moderate_breeze': 'brisa moderada',
  'wind.fresh_breeze': 'brisa fresca',
  'wind.strong_breeze': 'brisa fuerte',
  'wind.near_gale': 'frescachón',
  'wind.gale': 'temporal',
  'sun.dawn': 'amanecer',
  'sun.dusk': 'anochecer',
  'sun.morning': 'mañana',
  'sun.evening': 'tarde',
  'sun.rel_face': 'de frente',
  'sun.rel_back': 'de espaldas',
  'sun.rel_side': 'de lado',
  'sun.rel_below': 'bajo horizonte',
  'tackle.drag_slipping': 'freno cede',
  'tackle.hold': 'sostén',
  'tackle.beached': 'en orilla',
  'tackle.strike_now': '¡CLAVA!',
  'ui.btn_done': 'Hecho',
  'ui.btn_charge': 'Por pulsación',
  'reel.mode_body': 'Modo: Cuerpo',
  'reel.mode_crank': 'Modo: Manivela',
  'reel.mode_bail': 'Modo: Pick-up',
  'reel.mode_line': 'Modo: Línea',
  'state.world_built_already': 'mundo ya construido con estos números',
  'load.release_drag': 'SUELTA EL FRENO',
  'load.charge_over': 'EXCESO · EL LANCE CAERÁ A TUS PIES',
  'load.charge_hold': 'CARGANDO · SUELTA PARA LANZAR',
  'load.aim_swing': 'BALANCEO · MUEVE LA CAÑA',
  'load.trophy_hold': 'PEZ EN MANO · SUÉLTALO',
  'load.line_broken': 'LÍNEA ROTA · ATA UNA NUEVA',
  'load.long_hang': 'COLGANTE LARGO · RECOGE',
  'load.high_above_water': 'MUY ALTO · ACÉRCATE AL AGUA',
  'load.fish_nearby': 'PEZ CERCA - BAJA EL CEBO',
  'load.ready': 'LISTO PARA LANZAR',
  'load.landed': 'CAPTURADO',
  'load.lost': 'ESCAPÓ',
  'load.sagging': 'FLOJO — ¡RECOGE!',
  'load.biting': 'PICADA — ¡CLAVA!',
  'load.beached': 'EN LA ORILLA · RECOGE',
  'load.overload': 'SOBRECARGA · SUELTA EL FRENO',
  'load.cast_dist': 'distancia {m} m',
  'load.depth': 'profundidad {m} m',
  'load.bite_rate': 'probabilidad {p}%',
  'reel_dial.drag': 'FRENO',
  'reel_dial.reel': 'RECOGER',
  'line_dial.break': 'RUPTURA',
  'line_dial.left': 'RESERVA DE LÍNEA',
  'line_dial.broken': 'rota',
  'ui.unit_km': 'km',
  'map.search_placeholder': 'Buscar cuerpo de agua por nombre…',
  'map.search_btn': 'Buscar',
  'map.close_title': 'Cerrar (Esc)',
  'map.attribution': '© colaboradores de OpenStreetMap',
  'map.zoom': 'zoom',
  'map.status_searching': 'buscando…',
  'map.status_error': 'error: {err}',
  'map.status_empty': 'no se encontró nada',
  'map.status_found': 'se encontraron {n}',
  'map.status_network': 'sin red: {err}',
  'minimap.tooltip': 'Mapa del agua. Clic — pantalla completa',
  'minimap.header': 'Mapa',
  'minimap.close_title': 'Cerrar · Esc',
  'minimap.zoom_in': 'Acercar',
  'minimap.zoom_out': 'Alejar',
  'minimap.across': 'total {n} km a lo ancho',
  'minimap.legend_player': 'pescador',
  'minimap.legend_barrier': 'borde, no se puede avanzar',
  'minimap.legend_depth': 'números — profundidad, m',
  'lure.no_lip': 'sin babero',
  'tackle.drag_up_to': 'freno hasta',
  'ui.status_saving': 'guardando…',
  'ui.status_saved': 'sobrescrito',
  'ui.status_save_err': 'error: sin servidor dev',
  'ui.status_reset': 'restablecido',
  'ui.status_err': 'error de escritura',
  'ui.status_aim_ground': 'apunta al suelo',

  // ── Conteo: formas de plural, las elige Intl.PluralRules (i18n.ts) ────
  'count.fish_many': '{n} peces',
  'count.fish_one': '{n} pez',
  'count.fish_other': '{n} peces',
  'count.species_many': '{n} especies',
  'count.species_one': '{n} especie',
  'count.species_other': '{n} especies',
  'count.records_many': '{n} registros',
  'count.records_one': '{n} registro',
  'count.records_other': '{n} registros',
  'count.items_many': '{n} objetos',
  'count.items_one': '{n} objeto',
  'count.items_other': '{n} objetos',
  'count.waters_many': '{n} masas de agua',
  'count.waters_one': '{n} masa de agua',
  'count.waters_other': '{n} masas de agua',

  // ── Base de pesca: el vestíbulo ───────────────────────────────────────
  'lobby.waters': 'Aguas',
  'lobby.waters_sub': 'elige a dónde ir',
  'lobby.all_list': 'Lista completa',
  'lobby.world_map': 'Mapa del Mundo',
  'lobby.all_list_hint': 'Todos los países y aguas en una lista',
  'lobby.go': 'A pescar',
  'lobby.no_country': 'Sin país',
  'lobby.list_failed': 'No se pudo consultar al servidor.',
  'lobby.list_failed_hint':
    'Las aguas existen, pero la lista no llegó: el servidor de juego no respondió. No es una base vacía, es una conexión rota.',
  'lobby.empty': 'Aún no hay aguas.',
  'lobby.empty_admin':
    'Traza una orilla sobre un mapa real y aparecerá en esta lista, abriéndose también para los demás.',
  'lobby.empty_player':
    'El administrador las traza desde mapas reales. Vuelve más tarde: la primera ya está en camino.',
  'lobby.mirror': '{n} km² de espejo',
  'lobby.across': '{n} km de ancho',
  'lobby.depth': 'hasta {n} m de fondo',
  'lobby.no_fish': 'todavía sin peces',
  'lobby.mapped': 'trazado {when}',
  'lobby.base': 'Base de pesca',
  'lobby.level_short': 'niv. {n}',
  'lobby.logout': 'Salir',
  'lobby.trace_new': 'Trazar una nueva agua desde el mapa',
  'lobby.keepnet': 'Nasa',
  'lobby.empty': 'Aún no hay aguas.',
  'lobby.empty_admin':
    'Traza una orilla sobre un mapa real y aparecerá en esta lista, abriéndose también para los demás.',
  'lobby.empty_player':
    'El administrador las traza desde mapas reales. Vuelve más tarde: la primera ya está en camino.',
  'lobby.mirror': '{n} km² de espejo',
  'lobby.across': '{n} km de ancho',
  'lobby.depth': 'hasta {n} m de fondo',
  'lobby.no_fish': 'todavía sin peces',
  'lobby.mapped': 'trazado {when}',
  'lobby.base': 'Base de pesca',
  'lobby.level_short': 'niv. {n}',
  'lobby.logout': 'Salir',
  'lobby.trace_new': 'Trazar una nueva agua desde el mapa',
  'lobby.keepnet': 'Nasa',
  'lobby.keepnet_empty': 've a pescar y captura algo',
  'lobby.xp': 'Experiencia',
  'lobby.wallet': 'Cartera',
  'lobby.wallet_info': 'Aquí se guardan tus monedas. ¡Atrapa peces, véndelos en la tienda y compra mejores aparejos para atrapar peces aún más grandes!',
  'lobby.xp_line': 'Nivel {level}. Experiencia para el siguiente nivel: {xp}.',
  'lobby.xp_info': 'Cada pez que capturas te da experiencia. Cuanto más grande y raro sea el pez, más experiencia obtendrás. ¡Sube de nivel para desbloquear nuevos lugares!',
  'lobby.gold': 'Oro',
  'lobby.gold_info': 'Moneda premium. Permite comprar aparejos especiales y bonificaciones.',
  'lobby.pack_starter_title': 'Paquete Inicial',
  'lobby.pack_starter_desc': '100 Oro<br>250 XP<br>1000 Monedas',
  'lobby.pack_pro_title': 'Paquete Pro',
  'lobby.pack_pro_desc': '300 Oro<br>750 XP<br>3000 Monedas',
  'lobby.pack_master_title': 'Paquete Maestro',
  'lobby.pack_master_desc': '1000 Oro<br>2000 XP<br>10000 Monedas',
  'lobby.store_coming_soon': '¡Las compras con dinero real estarán disponibles pronto!',
  'lobby.wallet_line': '{coins} monedas · nivel {level}, {xp} de experiencia para el siguiente',
  'lobby.tackle': 'Mochila',
  'lobby.in_hands': 'En mano',
  'lobby.in_bag': 'En la mochila',
  'lobby.starter': 'inicial',
  'lobby.worn_now': 'Equipado: {name}',
    'lobby.records': 'Récords de jugadores',
  'lobby.records_none': 'todavía nadie ha marcado ninguno',
  'lobby.mine': 'Mis capturas',
  'lobby.open_wiki': 'abrir en la enciclopedia',
  'lobby.mine_none': 'el historial aún está vacío',
  'lobby.no_server': 'el servidor no respondió',
  'lobby.shop': 'Tienda',
  'lobby.shop_sub': 'aparejos, cebo, equipo',
  'shop.sell': 'Vender captura',
  'shop.rod': 'Cañas',
  'shop.reel': 'Carretes',
  'shop.line': 'Líneas',
  'shop.leader': 'Bajos de línea',
  'shop.hook': 'Anzuelos',
  'shop.lure': 'Señuelos',
  'shop.fly': 'Pesca a mosca',
  'shop.bait': 'Cebo',
  'shop.groundbait': 'Cebo de fondo',
  'shop.food': 'Comida',
  'shop.keepnet': 'Nasas',
  'shop.sonar': 'Sondas',
  'shop.boat': 'Barcas',
  'shop.gear': 'Equipo',
  'shop.soon': 'pronto',
  'lobby.shop_coins': 'En tu bolsa: {coins} mon.',
  'lobby.shop_sell': 'Vender la captura',
  'lobby.shop_buy': 'Comprar aparejos',
  'lobby.shop_sold': 'Peces vendidos: {n}',
  'lobby.shop_bought': 'Comprado: {name}',
  'lobby.tours': 'Torneos',
  'lobby.tours_sub': 'competiciones por tiempo y por peso',
  'lobby.club': 'Club de pescadores',
  'lobby.club_sub': 'amigos, rangos, salidas juntos',
  'lobby.soon': 'pronto',
  'lobby.atlas': 'A dónde vamos',
  'lobby.sheet_empty': 'Todavía nada',
  'lobby.close': 'Cerrar',
  'lobby.cancel': 'Cancelar',
  'lobby.logout_ask': '¿Cerrar la sesión?',
  'lobby.logout_note': 'Tus capturas y aparejos se quedan donde están. Para volver harán falta el correo y la contraseña.',
  'lobby.equipped': 'puesto · {slot}',
  'lobby.a_fish': 'pez',
  'lobby.account': 'Cuenta',
  'lobby.name': 'Nombre',
  'lobby.name_hint': 'Los demás pescadores ven este nombre: en los récords y en el agua.',
  'lobby.name_save': 'Guardar nombre',
  'lobby.name_done': 'Ahora te llamas {name}',
  'lobby.pass_new': 'Nueva contraseña',
  'lobby.pass_min': 'Mínimo 6 caracteres',
  'lobby.pass_again': 'Repite la contraseña',
  'lobby.pass_again_hint': 'Otra vez',
  'lobby.pass_save': 'Cambiar contraseña',
  'err.pass_mismatch': 'Las contraseñas no coinciden',
  'lobby.pass_done': 'Contraseña cambiada. La necesitarás en el próximo inicio de sesión.',
  'lobby.lang': 'Idioma del juego',
  'lobby.email_note': 'Inicias sesión con <b>{email}</b>. Nadie más puede verla.',
  'lobby.account_hint': 'Ajustes de la cuenta',
  'lobby.water_hint': 'Ajustes del agua',
  'lobby.fish_here': 'Qué peces viven aquí',
  'lobby.fish_note':
    'Una especie desmarcada deja de picar aquí. Un agua nueva las tiene todas marcadas, lista para pescar.',
  'lobby.save': 'Guardar',
  'lobby.fish_saved': 'Guardado: {list}',
  'lobby.fish_none_saved': 'El agua queda sin peces',

  // ── Países: la clave es el código ISO de los datos del mapa (lobby.ts) ─
  'country.ua': 'Ucrania',
  'country.de': 'Alemania',
  'country.it': 'Italia',
  'country.ch': 'Suiza',
  'country.no': 'Noruega',
  'country.si': 'Eslovenia',
  'country.fr': 'Francia',
  'country.se': 'Suecia',
  'country.ee': 'Estonia',
  'country.jp': 'Japón',
  'country.es': 'España',
  'country.pl': 'Polonia',
  'country.lt': 'Lituania',
  'country.lv': 'Letonia',
  'country.fi': 'Finlandia',
  'country.cz': 'Chequia',
  'country.at': 'Austria',
  'country.hu': 'Hungría',
  'country.ro': 'Rumanía',
  'country.gb': 'Reino Unido',
  'country.ie': 'Irlanda',
  'country.ca': 'Canadá',
  'country.us': 'Estados Unidos',

  'key.lmb': 'clic izq.',
  'key.rmb': 'clic der.',

  'menu.tobase': 'Volver a la base',
  'menu.tobase_sure': '¿Seguro? ¿Salir al lobby?',

  // ── Rechazos del servidor. La clave viaja con el texto (GameError) ────
  'err.fill_all': 'Rellena todos los campos',
  'err.bad_credentials': 'Correo o contraseña incorrectos',
  'err.bad_email': 'Formato de correo no válido',
  'err.short_password': 'La contraseña tiene menos de seis caracteres',
  'err.keepnet_full': 'La nasa está llena: {cap} peces. Vuelve a la base y vende la captura',
  'err.weak_password': 'La contraseña necesita letras latinas, un dígito y una mayúscula',
  'err.user_exists': 'Este usuario ya existe',
  'err.nothing_to_sell': 'No hay nada que vender',
  'err.already_sold': 'Este pez ya está vendido',
  'err.no_such_item': 'No existe ese objeto',
  'err.not_for_sale': 'Este objeto no está a la venta',
  'err.need_login': 'Necesitas iniciar sesión',
  'err.need_level': 'Se necesita el nivel {n}',
  'err.not_enough_coins': 'No hay monedas suficientes',
  'err.already_bought': 'Ya comprado',
  'err.wrong_slot': 'Ranura equivocada',
  'err.item_not_owned': 'No tienes este objeto',
  'err.no_water': 'No se ha indicado el agua',
  'err.no_fish_kinds': 'No se han indicado especies',
  'err.name_required': 'Introduce un nombre',
  'err.name_short': 'El nombre tiene menos de {n} caracteres',
  'err.name_long': 'El nombre supera los {n} caracteres',
  'err.name_at': 'El nombre no puede llevar @',
  'err.name_taken': 'Ese nombre ya está ocupado',
  'err.no_account': 'Cuenta no encontrada',
  'err.no_answer': 'El servidor no respondió',

  // ── Администрирование игроков ──
  'adm.players': "Jugadores",
  'adm.find': "Nombre, correo o IP",
  'adm.more': "Mostrar más",
  'adm.total': "total: {n}",
  'adm.loading': "cargando…",
  'adm.settings': "Ajustes del jugador",
  'adm.admin': "admin",
  'adm.player': "jugador",
  'adm.banned': "bloqueado",
  'adm.ok': "correcto",
  'adm.never': "nunca",
  'adm.now': "en línea",
  'adm.min_ago': "hace {n} min",
  'adm.hour_ago': "hace {n} h",
  'adm.day_ago': "hace {n} d",
  'adm.lvl': "niv. {n}",
  'adm.lvl_full': "Nivel",
  'adm.coins': "monedas",
  'adm.fish': "peces",
  'adm.things': "Objetos",
  'adm.role': "Rol",
  'adm.state': "Estado",
  'adm.registered': "Registrado",
  'adm.seen': "Última entrada",
  'adm.back': "a la lista",
  'adm.give': "Otorgar",
  'adm.rename': "Renombrar",
  'adm.newpass': "nueva contraseña",
  'adm.setpass': "Cambiar contraseña",
  'adm.reason': "motivo",
  'adm.ban': "Bloquear",
  'adm.unban': "Desbloquear",
  'adm.make_admin': "Hacer admin",
  'adm.make_player': "Degradar",
  'adm.last_catches': "Capturas recientes",
  'adm.logins': "Entradas",
  'adm.failed': "fallo",
  'adm.sure': "Seguro?",
  'adm.yes': "Si",

  // ── Гостевой вход ──
  'auth.or': "o",
  'auth.guest': "Entrar como invitado",
  'lobby.logout_guest': "Una cuenta de invitado no se puede recuperar: no tiene contrasena. El nivel, las monedas, la nasa y los records se perderan para siempre.",
  'lobby.guest_note': "Juegas como invitado. Anade un correo y una contrasena: todo el progreso se mantiene y podras entrar desde cualquier dispositivo.",
  'lobby.guest_email': "Correo",
  'lobby.guest_save': "Hacerla permanente",
  'lobby.guest_done': "Listo: la cuenta ya es permanente",
  'adm.guest': "invitado",
  'err.guest_many': "Demasiados invitados desde esta direccion. Intentalo mas tarde",
  'err.not_guest': "Esta cuenta ya es permanente",
  'err.email_taken': "Ese correo ya esta en uso",

  // ── Горячие клавиши ──
  'menu.ctl_gear': "Equipo",
  'menu.ctl_keepnet': "Nasa",
  'menu.ctl_map': "Mapa",

  // ── Качество картинки ──
  'set.q_max': "Maximo",
  'set.q_mid': "Medio",
  'set.q_min': "Minimo",
  'set.q_off': "Apagado",
  'set.reflection': "Reflejo en el agua",
  'set.reflection_hint': "Una segunda pasada de toda la escena en cada fotograma. Es lo mas caro despues de la escala: en un equipo debil, apagarlo da mas que todo lo demas junto.",
  'set.shadows': "Sombras",
  'set.shadows_hint': "Las sombras en cascada dibujan el mundo una vez por cascada. Un paso menos es una pasada menos por cada arbol.",
  'set.vegetation': "Vegetacion",
  'set.vegetation_hint': "Hasta donde se ven la hierba, los juncos y los arbustos. La mitad de radio es la cuarta parte del trabajo.",

  'set.clouds': "Nubes",
  'set.clouds_hint': "Se calculan por pixel de cielo y se repiten en el reflejo. Los pasos reducen el detalle del ruido, no las nubes.",

  'load.bytes': "{done} de {total} MB · {pct} %",

  'touch.cast': "Lanzar",

  'touch.reel': "Recoger",

  'menu.map': "Mapa",

  'loader.мир': "Contemplando el lugar",

  'load.bytes_only': "{done} MB descargados",
  "load.file_line": "{name} · {size} MB",
  "load.world_failed": "No se pudo abrir el embalse",
  "load.stalled": "La carga se alarga",
  "load.back_to_lobby": "Volver al registro",

  'touch.lamp': "Linterna",

  'set.hand': "Mano de la caña",
  'set.hand_hint': "Izquierda: botones a la izquierda, indicadores a la derecha. Derecha: al revés",
  'set.hand_left': "Izquierda",
  'set.hand_right': "Derecha",

  'shop.float': "Flotadores",
  'slot.float': "Flotador",
  'kit.спиннинг': "Spinning",
  'kit.удочка': "Caña de flotador",

  'item.cast': "lanza hasta",

  'reel_dial.depth': 'PROFUNDIDAD',
  'rod.float': 'de mosca fija',
  'rod.pole': 'de tramos',
  'rod.bolo': 'boloñesa',
  'rod.match': 'de match',
  'rod.feeder': 'feeder',
  'load.engine_failed': "No se pudo cargar el juego. Recarga la página.",
};
